const IMOToCb: Map<number, number> = new Map([
[9273923, 0.66],
[9273961, 0.66],
[9775751, 0.70],
[9775763, 0.70],
[9775737, 0.70],
[9775749, 0.70],
[9778533, 0.70],
[9778545, 0.70],
[9775775, 0.70],
[9164225, 0.66],
[9164237, 0.66],
[9164249, 0.66],
[9164251, 0.66],
[9164263, 0.66],
[9164275, 0.66],
[9175779, 0.66],
[9175781, 0.66],
[9175793, 0.66],
[9175808, 0.66],
[9192442, 0.67],
[9192454, 0.67],
[9192466, 0.67],
[9192478, 0.67],
[9220885, 0.67],
[9220897, 0.67],
[9348065, 0.68],
[9348077, 0.68],
[9348053, 0.68],
[9283186, 0.68],
[9283198, 0.68],
[9283227, 0.68],
[9283203, 0.69],
[9283215, 0.69],
[9357949, 0.67],
[9283239, 0.67],
[9332511, 0.70],
[9334662, 0.70],
[9334674, 0.70],
[9334686, 0.70],
[9357951, 0.70],
[9357963, 0.70],
[9357975, 0.70],
[9444728, 0.72],
[9444716, 0.72],
[9430375, 0.72],
[9444730, 0.72],
[9444742, 0.72],
[9425382, 0.72],
[9430363, 0.72],
[9484560, 0.69],
[9484572, 0.69],
[9430399, 0.72],
[9430387, 0.72],
[9444845, 0.72],
[9632129, 0.72],
[9632155, 0.72],
[9632090, 0.72],
[9632105, 0.72],
[9632167, 0.72],
[9632064, 0.72],
[9632117, 0.72],
[9632131, 0.72],
[9632143, 0.72],
[9632179, 0.72],
[9619907, 0.72],
[9619919, 0.72],
[9619921, 0.72],
[9619933, 0.72],
[9619945, 0.72],
[9619957, 0.72],
[9619969, 0.72],
[9619971, 0.72],
[9619983, 0.72],
[9619995, 0.72],
[9717204, 0.74],
[9717216, 0.74],
[9717228, 0.74],
[9778791, 0.71],
[9778806, 0.71],
[9778818, 0.71],
[9778820, 0.71],
[9778832, 0.71],
[9778844, 0.71],
[9780445, 0.71],
[9780457, 0.71],
[9780469, 0.71],
[9780471, 0.71],
[9780483, 0.71],
[9408956, 0.70],
[9411367, 0.70],
[9411379, 0.70],
[9411381, 0.70],
[9526875, 0.71],
[9526887, 0.71],
[9526899, 0.71],
[9526904, 0.71],
[9526916, 0.71],
[9526928, 0.71],
[9526930, 0.71],
[9526942, 0.71],
[9526954, 0.70],
[9526966, 0.70],
[9526978, 0.70],
[9527025, 0.70],
[9527037, 0.70],
[9527049, 0.70],
[9527051, 0.70],
[9527063, 0.70],
[9697014, 0.67],
[9724958, 0.67],
[9697026, 0.67],
[9292137, 0.64],
[9211482, 0.67],
[9215323, 0.67],
[9215311, 0.67],
[9211494, 0.67],
[9298686, 0.66],
[9298698, 0.66],
[9305300, 0.66],
[9305312, 0.66],
[9311701, 0.66],
[9314210, 0.66],
[9318319, 0.66],
[9315238, 0.67],
[9315197, 0.67],
[9315202, 0.67],
[9315240, 0.67],
[9315214, 0.67],
[9315226, 0.67],
[9315252, 0.67],
[9352004, 0.67],
[9352016, 0.67],
[9352030, 0.67],
[9352042, 0.67],
[9352028, 0.67],
[9525455, 0.67],
[9525297, 0.67],
[9525326, 0.67],
[9525376, 0.67],
[9525479, 0.67],
[9525405, 0.67],
[9525302, 0.67],
[9525340, 0.67],
[9525481, 0.67],
[9525493, 0.67],
[9525390, 0.67],
[9529255, 0.67],
[9525338, 0.67],
[9525285, 0.67],
[9525314, 0.67],
[9525352, 0.67],
[9525364, 0.67],
[9525388, 0.67],
[9525467, 0.67],
[9561497, 0.67],
[9526459, 0.67],
[9561485, 0.67],
[9622203, 0.73],
[9622215, 0.73],
[9622227, 0.73],
[9622239, 0.73],
[9622241, 0.73],
[9622253, 0.73],
[9633939, 0.73],
[9633941, 0.73],
[9633953, 0.73],
[9633965, 0.73],
[9699191, 0.69],
[9699189, 0.69],
[9699206, 0.69],
[9784271, 0.71],
[9784257, 0.71],
[9784283, 0.71],
[9784295, 0.71],
[9784300, 0.71],
[9784312, 0.71],
[9784324, 0.71],
[9784336, 0.71],
[9848948, 0.71],
[9848950, 0.71],
[9784269, 0.71],
[9193240, 0.66],
[9193264, 0.66],
[9193276, 0.66],
[9235531, 0.66],
[9235555, 0.66],
[9235543, 0.66],
[9235579, 0.66],
[9235567, 0.66],
[9348156, 0.65],
[9348168, 0.65],
[9348170, 0.65],
[9394882, 0.68],
[9394894, 0.68],
[9402029, 0.68],
[9409352, 0.68],
[9355288, 0.68],
[9355331, 0.68],
[9392925, 0.68],
[9394870, 0.68],
[9355343, 0.68],
[9355355, 0.68],
[9355367, 0.68],
[9348649, 0.65],
[9332987, 0.65],
[9332975, 0.65],
[9332999, 0.65],
[9342176, 0.65],
[9348651, 0.65],
[9333008, 0.65],
[9333010, 0.65],
[9333022, 0.65],
[9333034, 0.65],
[9153850, 0.68],
[9162215, 0.68],
[9153862, 0.68],
[9162227, 0.68],
[9786750, 0.66],
[9786762, 0.66],
[9786774, 0.66],
[9786786, 0.66],
[9797187, 0.66],
[9797204, 0.66],
[9797199, 0.66],
[9797216, 0.66],
[9332676, 0.67],
[9332688, 0.67],
[9168192, 0.61],
[9168207, 0.61],
[9168221, 0.61],
[9189342, 0.61],
[8819976, 0.66],
[8819988, 0.66],
[8819990, 0.66],
[9064384, 0.71],
[9120865, 0.68],
[9120853, 0.68],
[9120841, 0.68],
[9146455, 0.68],
[9146467, 0.68],
[9146479, 0.68],
[9166778, 0.68],
[9166780, 0.68],
[9166792, 0.68],
[9198575, 0.68],
[9198587, 0.68],
[9190743, 0.64],
[9190781, 0.64],
[9190755, 0.64],
[9190767, 0.64],
[9190731, 0.64],
[9190779, 0.64],
[9214898, 0.68],
[9214903, 0.68],
[9219795, 0.68],
[9219800, 0.68],
[9245770, 0.68],
[9245756, 0.68],
[9245768, 0.68],
[9260433, 0.66],
[9260419, 0.66],
[9260421, 0.66],
[9260457, 0.66],
[9260445, 0.66],
[9260469, 0.66],
[9294379, 0.64],
[9294393, 0.64],
[9294381, 0.64],
[9320245, 0.69],
[9320257, 0.69],
[9302889, 0.69],
[9302891, 0.69],
[9359040, 0.69],
[9302877, 0.69],
[9320233, 0.69],
[9359002, 0.69],
[9359014, 0.69],
[9359026, 0.69],
[9359052, 0.69],
[9359038, 0.69],
[9245744, 0.68],
[9321483, 0.64],
[9321495, 0.64],
[9321500, 0.64],
[9321512, 0.64],
[9321524, 0.64],
[9321536, 0.64],
[9321548, 0.64],
[9321550, 0.64],
[9603219, 0.66],
[9603221, 0.66],
[9602875, 0.66],
[9603233, 0.66],
[9625384, 0.66],
[9625396, 0.66],
[9342499, 0.66],
[9342504, 0.66],
[9342516, 0.66],
[9342528, 0.66],
[9215165, 0.60],
[9215177, 0.60],
[9215189, 0.60],
[9215191, 0.60],
[9251614, 0.63],
[9251638, 0.63],
[9251626, 0.63],
[9289180, 0.59],
[9289192, 0.59],
[9289207, 0.59],
[9313929, 0.62],
[9313931, 0.62],
[9313905, 0.62],
[9313917, 0.62],
[9313967, 0.62],
[9313943, 0.62],
[9313955, 0.62],
[9356086, 0.66],
[9356165, 0.66],
[9356103, 0.66],
[9356127, 0.66],
[9356139, 0.66],
[9356074, 0.66],
[9356098, 0.66],
[9356115, 0.66],
]);

export function getDefaultCbForIMO(imo: number): number
{
    let cb = IMOToCb.get(imo);

    if (!cb)
    {
        // IMO not part of our list; use fallback default
        cb = 0.68;
    }

    return cb;
}